const Regions = [
  { value: "Toute la France", label: "Toute la France" },
  { value: "Alsace", label: "Alsace" },
  { value: "Aquitaine", label: "Aquitaine" },
  { value: "Auvergne", label: "Auvergne" },
  { value: "Normandie", label: "Normandie" },
  { value: "Bourgogne", label: "Bourgogne" },
  { value: "Bretagne", label: "Bretagne" },
  { value: "Centre", label: "Centre" },
  { value: "Corse", label: "Corse" },
  { value: "Franche-Comté", label: "Franche-Comté" },
  { value: "Guadeloupe", label: "Guadeloupe" },
  { value: "Guyane", label: "Guyane" },
  { value: "Ile-de-France", label: "Ile-de-France" },
  { value: "Languedoc-Roussillon", label: "Languedoc-Roussillon" },
  { value: "La-Réunion", label: "La-Réunion" },
  { value: "Limousin", label: "Limousin" },
  { value: "Martinique", label: "Martinique" },
  { value: "Mayotte", label: "Mayotte" },
  { value: "Lorraine", label: "Lorraine" },
  { value: "Nord-Pas-de-Calais", label: "Nord-Pas-de-Calais" },
  { value: "Midi-Pyrénées", label: "Midi-Pyrénées" },
  { value: "Pays-de-la-Loire", label: "Pays-de-la-Loire" },
  { value: "Picardie", label: "Picardie" },
  { value: "Poitou-Charentes", label: "Poitou-Charentes" },
  { value: "Provence-Alpes-Côte-d'Azur", label: "Provence-Alpes-Côte-d'Azur" },
  { value: "Rhône-Alpes", label: "Rhône-Alpes" },
];

export default Regions;
